export default {
  NoSort: 0,
  SmallToLarge: 1,
  LargeToSmall: 2,
};
